import axiosClient from "../../../../../system/helpers/axiosConfig";

export const postNotificationStatus = (params) => {
  return axiosClient
    .post(
      `api/admin/notifications/global-notifications/${params.id}/${params.type}`
    )
    .then((r) => r.data.data);
};
